// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-section {
  padding: 40px 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  min-height: 100vh;
}

.gallery-container {
  text-align: center;
  margin-bottom: 30px;
}

.gallery-container h2 {
  font-size: 2.5rem;
  color: #3D1818;
  margin: 0 0 15px 0;
  font-weight: 200;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-family: 'Playfair Display', serif;
  text-shadow: none;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
  padding: 10px 0;
  max-width: 1400px;
  margin: 0 auto;
}

.gallery-item {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item picture {
  display: block;
  width: 100%;
  height: 100%;
}

.gallery-item:hover img {
  transform: scale(1.05);
}

.gallery-item-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(61, 24, 24, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .gallery-item-overlay {
  opacity: 1;
}

.zoom-icon {
  font-size: 3rem;
  color: #FAF6E7;
}

/* Photo Slider Modal */
.gallery-slider-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.gallery-slider-content {
  position: relative;
  width: 90vw;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-image-container {
  position: relative;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-image-container img {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.slider-image-container picture {
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid #FAF6E7;
  color: #FAF6E7;
  font-size: 2rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10001;
}

.slider-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

.slider-nav {
  position: absolute;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid #FAF6E7;
  color: #FAF6E7;
  font-size: 3rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10001;
}

.slider-nav:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.slider-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.slider-prev {
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.slider-prev:hover:not(:disabled) {
  transform: translateY(-50%) scale(1.1);
}

.slider-next {
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.slider-next:hover:not(:disabled) {
  transform: translateY(-50%) scale(1.1);
}

.slider-counter {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  color: #FAF6E7;
  font-size: 1.2rem;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px 20px;
  border-radius: 20px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .gallery-section {
    padding: 40px 15px;
  }

  .gallery-container h2 {
    font-size: 2rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 20px;
    padding: 0 20px;
  }

  .zoom-icon {
    font-size: 2rem;
  }

  .slider-nav {
    width: 50px;
    height: 50px;
    font-size: 2rem;
  }

  .slider-close {
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }

  .slider-counter {
    bottom: -40px;
    font-size: 1rem;
    padding: 6px 16px;
  }

  .slider-image-container img {
    max-width: 95vw;
    max-height: 80vh;
  }
}

@media (max-width: 480px) {
  .gallery-section {
    padding: 30px 10px;
  }

  .gallery-container h2 {
    font-size: 1.8rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Gallery.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;IAC5D,QAAQ;EACV;AACF","sourcesContent":[".gallery-section {\n  padding: 40px 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  min-height: 100vh;\n}\n\n.gallery-container {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.gallery-container h2 {\n  font-size: 2.5rem;\n  color: #3D1818;\n  margin: 0 0 15px 0;\n  font-weight: 200;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  font-family: 'Playfair Display', serif;\n  text-shadow: none;\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 25px;\n  padding: 10px 0;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.gallery-item {\n  position: relative;\n  aspect-ratio: 1;\n  overflow: hidden;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.gallery-item:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n}\n\n.gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.gallery-item picture {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.gallery-item:hover img {\n  transform: scale(1.05);\n}\n\n.gallery-item-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(61, 24, 24, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.gallery-item:hover .gallery-item-overlay {\n  opacity: 1;\n}\n\n.zoom-icon {\n  font-size: 3rem;\n  color: #FAF6E7;\n}\n\n/* Photo Slider Modal */\n.gallery-slider-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.gallery-slider-content {\n  position: relative;\n  width: 90vw;\n  height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-image-container {\n  position: relative;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-image-container img {\n  max-width: 90vw;\n  max-height: 85vh;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.slider-image-container picture {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.slider-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid #FAF6E7;\n  color: #FAF6E7;\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10001;\n}\n\n.slider-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: rotate(90deg);\n}\n\n.slider-nav {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid #FAF6E7;\n  color: #FAF6E7;\n  font-size: 3rem;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10001;\n}\n\n.slider-nav:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.slider-nav:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.slider-prev {\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.slider-prev:hover:not(:disabled) {\n  transform: translateY(-50%) scale(1.1);\n}\n\n.slider-next {\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.slider-next:hover:not(:disabled) {\n  transform: translateY(-50%) scale(1.1);\n}\n\n.slider-counter {\n  position: absolute;\n  bottom: -50px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #FAF6E7;\n  font-size: 1.2rem;\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 8px 20px;\n  border-radius: 20px;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .gallery-section {\n    padding: 40px 15px;\n  }\n\n  .gallery-container h2 {\n    font-size: 2rem;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 20px;\n    padding: 0 20px;\n  }\n\n  .zoom-icon {\n    font-size: 2rem;\n  }\n\n  .slider-nav {\n    width: 50px;\n    height: 50px;\n    font-size: 2rem;\n  }\n\n  .slider-close {\n    width: 40px;\n    height: 40px;\n    font-size: 1.5rem;\n  }\n\n  .slider-counter {\n    bottom: -40px;\n    font-size: 1rem;\n    padding: 6px 16px;\n  }\n\n  .slider-image-container img {\n    max-width: 95vw;\n    max-height: 80vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-section {\n    padding: 30px 10px;\n  }\n\n  .gallery-container h2 {\n    font-size: 1.8rem;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
